import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import ComicTitle from './ui/ComicTitle';

export const Categories = () => {
  const categories = [
  {
      name: "Real Talk",
      color: "hsl(var(--category-real-talk))",
      icon: "/assets/rt.png",
      description: "Encourage honest dialogue about personal experiences with bullying.",
      examples: ["Share experiences", "Reflect on actions", "Learn from past"],
  },
  {
      name: "Stand Up & Speak Out",
      color: "hsl(var(--category-stand-up))",
      icon: "/assets/suso.png",
      description: "Build courage and skills for taking a stand in real-life situations.",
      examples: ["Practice responses", "Support others", "Find your voice"],
  },
  {
      name: "Behind the Mask",
      color: "hsl(var(--category-behind-mask))",
      icon: "/assets/btm.png",
      description: "Promote empathy by understanding the emotional struggles of others.",
      examples: ["Explore emotions", "Build understanding", "See beyond surface"],
  },
  {
      name: "Power Moves",
      color: "hsl(var(--category-power-moves))",
      icon: "/assets/pm.png",
      description: "Strengthen self-worth, confidence, and leadership abilities.",
      examples: ["Build confidence", "Lead by example", "Stay true to yourself"],
  },
  {
      name: "Ripple Effect",
      color: "hsl(var(--category-ripple))",
      icon: "/assets/re.png",
      description: "Explore how actions influence others, both positively and negatively.",
      examples: ["Recognize impact", "Create positive change", "Inspire others"],
  },
  {
      name: "Drop the Mic",
      color: "hsl(var(--category-drop-mic))",
      icon: "/assets/dtm.png",
      description: "Speak powerful truths and own your voice with confidence.",
      examples: ["Express boldly", "Stand your ground", "Make a statement"],
  },
  {
      name: "Pop-Off Play",
      color: "hsl(var(--category-pop-off))",
      icon: "/assets/fi.png",
      description: "Build connection, laughter, and trust through playful activities that encourage teamwork and break the ice.",
      examples: ["Healthy coping", "Bounce back", "Ground yourself"],
  },
  {
      name: "Self-Care Squad",
      color: "hsl(var(--category-self-care))",
      icon: "/assets/scs.png",
      description: "Explore healthy coping mechanisms and self-care strategies.",
      examples: ["Manage anxiety", "Build resilience", "Practice self-compassion"],
  },
  {
      name: "Drop the Anchor",
      color: "hsl(var(--category-drop-anchor))",
      icon: "/assets/dta.png",
      description: "Simple ways to calm your mind and feel more grounded.",
      examples: ["Breathing exercises", "Mindful moments", "Finding peace"],
  },
  {
      name: "Flip the Script",
      color: "hsl(var(--category-flip-script))",
      icon: "/assets/fts.png",
      description: "Transform negative situations into positive actions.",
      examples: ["Rewrite narratives", "Create inclusion", "Shift energy"],
  },
  ];

  return (
    <section id="categories" className="py-20 bg-muted/30 halftone-bg">
      <div className="container mx-auto px-4">
        <div className="mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <ComicTitle text="10 Powerful Categories" shadowColor="#0066FF" highlightColor="#67e8f9"/>
            <div className="w-24 h-1.5 bg-gradient-to-r from-primary via-secondary to-accent mx-auto rounded-full mb-8"></div>
            <p className="text-2xl font-bold text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Each category is designed to spark meaningful conversations, build empathy, and empower students to create positive change.
            </p>
          </div>

          {/* Categories Grid */}
          <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">
            {categories.map((category, index) => (
              <Card
                  key={index}
                  className={`group relative overflow-hidden rounded-[18px] border-[4px] border-black bg-[#f8f4ea] p-0 text-black shadow-[5px_5px_0_#000] transition-all duration-300 hover:-translate-y-2 hover:scale-[1.02] ${
                      index % 2 === 0 ? "hover:-rotate-[1deg]" : "hover:rotate-[1deg]"
                  }`}
              >
                  {/* top accent strip */}
                  <div
                      className="h-2.5 w-full border-b-[4px] border-black"
                      style={{ backgroundColor: category.color }}
                  />

                  <div className="p-4">
                      {/* icon + title */}
                      <div className="mb-3 flex items-start gap-3">
                          <div
                              className="flex h-16 w-16 shrink-0 items-center justify-center rounded-[16px] border-[4px] border-black bg-white shadow-[3px_3px_0_#000]"
                              style={{ backgroundColor: `${category.color}15` }}
                          >
                              <img
                                  src={category.icon}
                                  alt={`${category.name} icon`}
                                  className="h-full w-full object-contain"
                              />
                          </div>

                          <div className="min-w-0 pt-1">
                              <h3 className="text-xl font-bold uppercase leading-tight tracking-wide transition-transform duration-300 group-hover:scale-[1.02]">
                                  {category.name}
                              </h3>
                          </div>
                      </div>

                      {/* description */}
                      <p className="mb-4 text-[0.92rem] font-semibold leading-6 text-black/80">
                          {category.description}
                      </p>

                      {/* compact example rows */}
                      <div className="overflow-hidden rounded-[14px] border-[3px] border-black bg-white shadow-[3px_3px_0_#000]">
                          {category.examples.map((example, i) => (
                              <div
                                  key={i}
                                  className={`px-3 py-2 text-[0.72rem] font-bold tracking-wider uppercase tracking-wide ${
                                      i !== category.examples.length - 1 ? "border-b-[3px] border-slate-500" : ""
                                  }`}
                                  style={{
                                      backgroundColor: i % 2 === 0 ? `${category.color}14` : "#ffffff",
                                  }}
                              >
                                  {example}
                              </div>
                          ))}
                      </div>
                  </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
